import React, { Component } from 'react';
import autoBindMethods from 'class-autobind-decorator';
import { inject, observer } from 'mobx-react';
import { MenuItem } from 'react-bootstrap-typeahead';
import { find, get } from 'lodash';

import FormattingUtils from '../../../../utils/FormattingUtils';
import { OptionsStoreClass } from '../../../../stores';
import { IOption } from '../../../../stores/OptionsStoreClass';

import {
  getBaseSearchResultDisplayItem,
  IDisplaySearchResultItemConfiguration,
  ISearchResultItemProps,
} from './SearchResultUtils';

const { getOrDefault } = FormattingUtils;

interface IProps extends ISearchResultItemProps {
  OptionsStore: OptionsStoreClass;
}

@inject('OptionsStore')
@autoBindMethods
@observer
class LoanAccountSearchResultItem extends Component<IProps> {
  // Type and status come back as raw enum values, labelled from the lists /options/ serves.
  private optionLabel (options: IOption[], value: string) {
    return getOrDefault(get(find(options, (option: IOption) => option.value === value), 'name'));
  }

  public render () {
    const { item, OptionsStore } = this.props
      , displayItemConfiguration: IDisplaySearchResultItemConfiguration = {
        ...this.props,
        entity: 'loanaccount',
        // The account's own page, which the router redirects to its details tab
        path: '/loan-accounts/',
      }
      , displayItem = getBaseSearchResultDisplayItem(displayItemConfiguration)
      ;

    return (
      <MenuItem key={item.id} option={displayItem} position={item.index}>
        <div className='search-result-item'>
          <p>
            <span className='pull-right'>{this.optionLabel(OptionsStore.loanAccountStatusOptions, item.status)}</span>
            <strong>{displayItem.name}</strong>
          </p>
          <p className='sub-info'>{this.optionLabel(OptionsStore.loanAccountTypeOptions, item.type)}</p>
        </div>
      </MenuItem>
    );
  }
}

export default LoanAccountSearchResultItem;
